import { EditCoverPosterListItem } from "../types";

export const editCoverPosterListKeyExtractor = (item: EditCoverPosterListItem) => {
	return item.assetId;
};
